"use client";

import React from "react";

import ImageConstant from "@/common/constants/image";
import { Images, ProductImage2 } from "@/types/Product.type";

import Image from "@/components/ui/Image";
import Carousel from "@/components/Carousel";

interface ProductImagesProps {
  images: Images[];
  indexActive: number;
  onChangeImage: (index: number) => void;
}

const handleRenderBanner = (item: ProductImage2, index: number) => {
  return (
    <Image
      key={index}
      width={414}
      height={414}
      className="object-cover object-bottom h-[414px] w-full"
      src={item.url}
      alt="img"
      placeholder={"blur"}
      blurDataURL={ImageConstant.BlurDataURL}
    />
  );
};
function ProductImagesMobile({
  images,
  indexActive,
  onChangeImage,
}: ProductImagesProps) {
  return (
    <>
      <div className="min-h-[414px] slide-image-mobile relative mb-[10px]">
        <Carousel
          data={images}
          initialSlide={indexActive}
          speed={1000}
          itemSlider={handleRenderBanner}
          navigation={false}
          onSlideChange={(e) => {
            onChangeImage(e.activeIndex);
          }}
          freeMode={false}
          autoplay={false}
          slidesPerView={1}
        />
      </div>

      <div className=" flex items-center justify-center">
        <p className="px-[5px] py-[2px] w-fit bg-white border text-gray-500 border-gray-300 z-10  rounded-md text-xs">
          {`${indexActive + 1}/${images.length}`}
        </p>
      </div>
    </>
  );
}

export default ProductImagesMobile;
